module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_c('canvas', {
    staticClass: "canvas",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-area clearfix"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "right": "0"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("message.title")))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t("message.banner")))]), _vm._v(" "), _c('router-link', {
    staticClass: "blue-btn",
    attrs: {
      "to": "/Report"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.bannerButtonTxt")))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "index-area vulnerability"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("message.vuln.title")))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.vuln.text'))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.vulnImg
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-515264ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-515264ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 771
// module chunks = 7